import styled, { css } from 'styled-components';

import { black, chartOrange, chartJaffaOrange } from 'styles/colors';
import { ApButtonMain } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	background-color: ${({ bgColor }) => bgColor};
	padding: 16px 19px 23px 1px;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 18px;

	&:nth-child(2) {
		flex-grow: 1;
	}
`;

export const Title = styled.div`
	color: ${black};
	font-size: 16px;
	font-weight: bold;
	letter-spacing: 0.3px;
	line-height: 24px;
	margin-bottom: 11px;
	margin-top: 4px;
`;

export const BodyText = styled.div`
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 24px;
`;

export const StyledButton = styled(ApButtonMain)`
	${({ color }) =>
		color === 'orange' &&
		css`
			background: ${chartOrange} !important;

			&:hover {
				background: ${chartJaffaOrange} !important;
			}
		`};
`;
